// @ts-nocheck
import React from 'react';
import IntegrationsEnhanced from './IntegrationsEnhanced';

const Integrations: React.FC = ({clientId: propClientId}) => {
    // Delegate to the enhanced version
    return <IntegrationsEnhanced clientId={propClientId} />;
};

export default Integrations;